import color from '../assets/logo-comuna.png';
import inverse from '../assets/logo-comuna-inverso.png';

/** Proporción del logo oficial de la Comuna (ancho / alto). */
const RATIO = 368 / 185;

/**
 * Logo oficial de la Comuna de Empalme Villa Constitución.
 * "auto" sigue el tema del sistema; "inverse" es para fondos azules.
 */
export function Logo({ height = 40, variant = 'auto' }: { height?: number; variant?: 'auto' | 'inverse' }) {
  const img = (src: string) => (
    <img src={src} alt="Comuna de Empalme Villa Constitución" height={height} width={Math.round(height * RATIO)} className="block" />
  );
  if (variant === 'inverse') return img(inverse);
  return (
    <picture>
      <source srcSet={inverse} media="(prefers-color-scheme: dark)" />
      {img(color)}
    </picture>
  );
}
